import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import "./css/index.scss";
import { store } from "./libs/Utils/store";
import { Provider } from "react-redux";
import { CountryCodeProvider } from "./global components/Context/CountryCode";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ToggleProvider } from "./global components/Context/NavbarContext";
import { ToastProvider } from "./global components/Toast";
import { DraftProvider } from "./global components/Context/DraftContext";
import { ConfirmationModalProvider } from "./global components/Context/ConfirmationModalContext";
import { router } from "./router";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

window.history.scrollRestoration = "manual";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider />
      <DraftProvider>
        <CountryCodeProvider>
          <ConfirmationModalProvider>
            <ToggleProvider>
              <RouterProvider router={router} />
            </ToggleProvider>
          </ConfirmationModalProvider>
        </CountryCodeProvider>
      </DraftProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
